import * as React from 'react';
import PropTypes from 'prop-types';
import { withRouter, Redirect } from 'react-router-dom';
import PubSub from 'services/pubsub-service';
import * as PubSubActionType from 'services/constants';
import { checkRoute, checkAllSystemRoute } from '../helper/check-route-helper';
import { AppSettings } from '../constants';
import PrivateRoute from 'components/Router/PrivateRoute';
import PublicRoute from 'components/Router/PublicRoute';
import Layout from '../layout';
import Sidebar from '../sidebar';
import user_routes from '../User/routes';
import insurance_routes from '../Insurance/routes';
import request_routes from '../Request-Types/routes';
import project_routes from '../Projects/routes';
import clients_routes from '../Subcontractors/routes';
import room_routes from '../Rooms/routes';
import model_routes from '../Model/routes';
import work_routes from '../Work-Order-Type/routes';
import work_order_routes from '../Work-Orders/routes';
import lots_routes from '../Lots/routes';
import rs_routes from '../Request-Services/routes';
import ml_routes from '../MediaLibrary/routes';
import region_market from '../Region-Market/routes';
import auth_routes from '../Auth/routes';
import auth from 'Auth/authenticator';
import builder_routes from 'Builders/routes';
import items_routes from 'Items/routes';
import setting_routes from 'Setting/routes';
import component_routes from '../ExampleComponent/routes';
import error_page_routers from '../errorPage/routers';
import cost_code_routers from '../CostCodes/routers';
// import ManageRFS from '../Request-Services/Containers/manage-rfs';
import home_owners_routes from '../HomeOwners/routes';
import manage_roles from '../Manage-Roles/routes';
import punch_list_routes from '../Punch-List/routes';
// import izenda_routes from '../izenda/routers';
// import ErrorPage from 'errorPage/ErrorPage';
import NotFoundPage from 'errorPage/404';
import AccessDeniedPage from 'errorPage/403';
// import BuilderDashboard from 'izenda/containers/builder-dashboard';
import BuilderDashBoard from 'Dashboard/Containers/builder-dashboard';
import dashboard_routes from '../Dashboard/routes';
import activity_routes from 'Activities/routes';
import default_config from '../DefaultConfig/routers'
class AppRoutes extends React.Component {
  static propTypes = {
    history: PropTypes.any,
    authenticated: PropTypes.bool,
    location: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = {
      accessDenied: false
    };
  }

  componentDidMount() {
    PubSub.subscribe(PubSubActionType.ACCESS_DENIED_ERROR, () => {
      this.setState({
        accessDenied: true
      });
    });

    PubSub.subscribe(PubSubActionType.RESET_HANDLING_ERROR, () => {
      this.setState({
        accessDenied: false
      });
    });
  }

  renderSidebar = (routes, roleName) => {
    const isSSOUser = localStorage.getItem(AppSettings.S1_SSO); // Internal using "Goto builder site"
    const isExternalSSOUser = localStorage.getItem(AppSettings.IS_SSO_USER); // External using Auth token
  
    let groupMenu = {};
    if (
      roleName === AppSettings.BUILDER_SUPER_ADMIN ||
      roleName === AppSettings.BUILDER_ADMIN
    ) {
      if (isExternalSSOUser=== 'True' || isExternalSSOUser === true || isSSOUser === true || isSSOUser === 'true') {
        groupMenu = [
          {
            group: 'Subcontractor',
            icon: 'icon-subcontractors-root-ic',
            name: 'Subcontractors management',
            className: 'menu-divide',
            menu: {
              isGroup: true,
              order: 12
            }
          },
          {
            group: 'Report',
            icon: 'pe-7s-graph3',
            name: 'Reports management',
            menu: {
              isGroup: true,
              order: 13
            }
          },
          {
            group: 'Admin',
            icon: 'icon-admin-ultilities-ic',
            name: 'Admin utilities',
            subGroup: [
              { key: 'General', name: 'General' },
              { key: 'Other', name: 'Other' }
            ],
            menu: {
              isGroup: true,
              order: 15
            }
          }
        ];
      } else {
        groupMenu = [
          {
            group: 'Subcontractor',
            icon: 'icon-subcontractors-root-ic',
            name: 'Subcontractors management',
            className: 'menu-divide',
            menu: {
              isGroup: true,
              order: 12
            }
          },
          {
            group: 'Report',
            icon: 'pe-7s-graph3',
            name: 'Reports management',
            menu: {
              isGroup: true,
              order: 13
            }
          },
          {
            group: 'Admin',
            icon: 'icon-admin-ultilities-ic',
            name: 'Admin utilities',
            subGroup: [
              { key: 'General', name: 'General' },
              { key: 'Other', name: 'Other' }
            ],
            menu: {
              isGroup: true,
              order: 15
            }
          }
        ];
      }
    } else {
      groupMenu = [
        {
          group: 'Subcontractor',
          icon: 'icon-subcontractors-root-ic',
          name: 'Subcontractor',
          className: 'menu-divide',
          menu: {
            isGroup: true,
            order: 12
          }
        },
        {
          group: 'Report',
          icon: 'icon-admin-ultilities-ic',
          name: 'Report',
          menu: {
            isGroup: true,
            order: 13
          }
        }
      ];
    }
    return (
      <Sidebar
        key='sidebar'
        routes={routes}
        groupMenu={groupMenu}
        location={this.props.location}
      />
    );
  };

  renderRoutes = roleName => {
    console.log('rolename',roleName);
    const isSSOUser = localStorage.getItem(AppSettings.S1_SSO);
    let routes = [];
    if (
      roleName === AppSettings.BUILDER_SUPER_ADMIN ||
      roleName === AppSettings.BUILDER_ADMIN
    ) {
      routes = [].concat(
        auth_routes,
        insurance_routes,
        request_routes,
        project_routes,
        clients_routes,
        room_routes,
        model_routes,
        work_routes,
        work_order_routes,
        ml_routes,
        lots_routes,
        rs_routes,
        region_market,
        user_routes,
        builder_routes,
        items_routes,
        setting_routes,
        component_routes,
        error_page_routers,
        cost_code_routers,
        home_owners_routes,
        manage_roles,
        punch_list_routes,
        activity_routes,
        dashboard_routes,
        default_config
      );
    } else {
      routes = [].concat(
        auth_routes,
        project_routes,
        clients_routes,
        model_routes,
        lots_routes,
        rs_routes,
        ml_routes,
        work_order_routes,
        builder_routes,
        component_routes,
        error_page_routers,
        home_owners_routes,
        punch_list_routes,
        activity_routes,
        dashboard_routes
      );
    }
    //REMOVE IZENDA TEMPORARY CHANGE RENDER COMPONENT
    routes.push({
      path: '/',
      component: BuilderDashBoard,
      private: true
    });
    //REMOVE IZENDA TEMPORARY CHANGE RENDER COMPONENT
    if (isSSOUser !== 'true') {
      //REMOVE IZENDA TEMPORARY CHANGE RENDER COMPONENT
      // routes = [].concat(routes, izenda_routes);
      routes = [].concat(routes);
    }
    user_routes.map(userRoute => {
      if (userRoute.path === '/my-profile') {
        routes.push(userRoute);
      }
    });
    console.log('routes in portal builder', routes);
    return routes;
  };

  render() {
    if (this.state.accessDenied) {
      return <AccessDeniedPage />;
    }

    const authenticated = auth.loggedIn();
    const roleName = auth.getRoleName();
    console.log('Builder Rolename', roleName)
    var routes = this.renderRoutes(roleName);
    let privateRoute = null;
    let publicRoute = null;

    const matchRoute = checkRoute(routes, this.props.location.pathname);

    const nextUrl = this.props.location.pathname;

    if (matchRoute) {
      if (matchRoute.private) {
        privateRoute = matchRoute;
      } else {
        publicRoute = matchRoute;
      }
    }

    const queryParams = new URLSearchParams(this.props.location.search);
    const isPublic = queryParams.get('public');

    if (privateRoute) {
      if (!localStorage[AppSettings.S1_TOKEN]) {
        if (isPublic || isPublic === 'true') {
          return (
            <Redirect to={`/public${nextUrl}${this.props.location.search}`} />
          );
        } else {
          return (
            <Redirect
              to={`/sign-in?nextUrl=${nextUrl}${this.props.location.search}`}
            />
          );
        }
      }
      return (
        <Layout
          history={this.props.history}
          routes={routes}
          location={this.props.location}
          renderSidebar={() => this.renderSidebar(routes, roleName)}
        >
          <PrivateRoute
            authed={authenticated}
            component={privateRoute.component}
            // routes={route.routes}
            exact
            path={privateRoute.path}
            key={'private'}
          />
        </Layout>
      );
    }
    if (publicRoute) {
      return (
        <PublicRoute
          authed={authenticated}
          component={publicRoute.component}
          // routes={route.routes}
          exact
          path={publicRoute.path}
          key={'private'}
        />
      );
    }

    if (!authenticated) {
      return (
        <Redirect
          to={`/sign-in?nextUrl=${nextUrl}${this.props.location.search}`}
        />
      );
    }

    if (checkAllSystemRoute(this.props.location.pathname)) {
      return <AccessDeniedPage />;
    }

    // return <ErrorPage errorType='error404' />;
    return <NotFoundPage />;
    // return <Redirect to='/'/>;
  }
}
/*eslint-disable */
export default withRouter(AppRoutes);
/*eslint-enable */
// export default AppRoutes;



// WEBPACK FOOTER //
// ./src/portal_builder/router.js